import React from "react";

const Textiles = () => {
  return (
    <div>
      <h1>Textiles & Garments</h1>
      <p>Details about Textiles & Garments products...</p>
    </div>
  );
};

export default Textiles;
